/* eslint-disable import/first */
import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'
import Cookies from 'universal-cookie'

import { createBrowserHistory } from 'history'
import { Router, Route, Switch } from 'react-router-dom'
import Service from './lib/Service'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.js'
import 'font-awesome/css/font-awesome.min.css'
// eslint-disable-next-line no-undef
import(`assets/scss/${process.env.REACT_APP_TEMPLATE || 'academy'}.css`)

import 'flag-icon-css/css/flag-icon.min.css'

import indexRoutes from 'routes/index.jsx'
import api from './api/api'

const hist = createBrowserHistory()

const cookies = new Cookies()

let countryCodes = {}
let supportedLngs = []
const systemP = new Promise((resolve) => api.getConfig().then((system) => resolve(system)))
systemP.then(({ language }) => {
    if (language) {
        const { available } = language
        if (available) {
            available.forEach(({ key, countryCode }) => countryCodes[key] = countryCode)
            supportedLngs = available.map(({ key }) => key)
        }
    } else {
        countryCodes['en'] = 'US'
        supportedLngs.push('en')
    }
    // eslint-disable-next-line no-undef
    const langPack = process.env.REACT_APP_LANG_PACK || 'translation'
    i18n.use(initReactI18next).use(LanguageDetector).use(HttpApi)
        .init({
            supportedLngs,
            fallbackLng: 'en',
            detection: {
                order: ['cookie', 'path', 'htmlTag', 'localStorage', 'subdomain'],
                caches: ['cookie'],
            },
            backend: {
                loadPath: `/assets/locales/{{lng}}/${langPack}.json`,
            },
        })
    const userBrowserLang = navigator.language.split('-')[0]
    const lang = cookies.get('i18next') || userBrowserLang
    i18n.changeLanguage(lang)
    cookies.set('countryCode', countryCodes[lang], { path: '/' })

    const loadingMarkup = (
        <div className="py-4 text-center">
            <h2>Loading...</h2>
        </div>
    )

    ReactDOM.render(
        <Suspense fallback={loadingMarkup}>
            <Service />
            <Router history={hist}>
                <Switch>
                    {indexRoutes.map((prop, key) => {
                        return (
                            <Route path={prop.path} key={key} component={prop.component} />
                        )
                    })}
                </Switch>
            </Router>
        </Suspense>,
        document.getElementById('root'),
    )
}).catch(() => {
    // eslint-disable-next-line no-undef
    const langPack = process.env.REACT_APP_LANG_PACK || 'translation'
    i18n
        .use(initReactI18next)
        .use(LanguageDetector)
        .use(HttpApi)
        .init({
            supportedLngs: ['en'],
            fallbackLng: 'en',
            detection: {
                order: ['cookie', 'path', 'htmlTag', 'localStorage', 'subdomain'],
                caches: ['cookie'],
            },
            backend: {
                loadPath: `/assets/locales/{{lng}}/${langPack}.json`,
            },
        })

    const lang = 'en'
    i18n.changeLanguage(lang)
    cookies.set('countryCode', 'US', { path: '/' })

    const loadingMarkup = (
        <div className="py-4 text-center">
            <h2>Loading...</h2>
        </div>
    )
    ReactDOM.render(
        <Suspense fallback={loadingMarkup}>
            <Service />
            <Router history={hist}>
                <Switch>
                    {indexRoutes.map((prop, key) => {
                        return (
                            <Route path={prop.path} key={key} component={prop.component} />
                        )
                    })}
                </Switch>
            </Router>
        </Suspense>,
        document.getElementById('root'),
    )
})


// WEBPACK FOOTER //
// ./src/index.js